// export default function downloadCSV(
//   tableData = [],
//   csvName = "table_data.csv"
// ) {
//   const convertToCSV = () => {
//     const csvContent =
//       "data:text/csv;charset=utf-8," +
//       Object.keys(tableData[0]).join(",") +
//       "\n" +
//       tableData.map((item) => Object.values(item).join(",")).join("\n");
//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", `${csvName}.csv`);
//     document.body.appendChild(link);
//     link.click();
//   };

//   convertToCSV();
// }
// export default function downloadCSV(
//   tableData = [],
//   csvName = "table_data.csv"
// ) {
//   // Function to escape values that might have commas or newlines
//   const escapeValue = (value) => {
//     if (typeof value === "string") {
//       // If the value contains commas, new lines, or quotes, wrap it in quotes and escape internal quotes
//       if (value.includes(",") || value.includes("\n") || value.includes('"')) {
//         return `"${value.replace(/"/g, '""')}"`;
//       }
//     }
//     return value; // Return the value as is if no special characters
//   };

//   // Create CSV content
//   const csvContent =
//     "data:text/csv;charset=utf-8," +
//     Object.keys(tableData[0])
//       .map((key) => escapeValue(key)) // Escape keys (headers) if needed
//       .join(",") +
//     "\n" +
//     tableData
//       .map((item) =>
//         Object.values(item)
//           .map((value) => escapeValue(value)) // Escape each value
//           .join(",")
//       )
//       .join("\n");

//   // Create a link to download the CSV
//   const encodedUri = encodeURI(csvContent);
//   const link = document.createElement("a");
//   link.setAttribute("href", encodedUri);
//   link.setAttribute("download", `${csvName}.csv`);
//   document.body.appendChild(link);
//   link.click();
//   link.remove();
// }

export default function downloadCSV(
  tableData = [],
  csvName = "table_data.csv"
) {
  if (!Array.isArray(tableData) || tableData.length === 0) {
    console.warn("No data provided for CSV download.");
    return;
  }

  // Escape values to handle commas, quotes, and newlines
  const escapeValue = (value) => {
    if (value === null || value === undefined) return "";
    const str = String(value);
    if (str.includes(",") || str.includes("\n") || str.includes('"')) {
      return `"${str.replace(/"/g, '""')}"`; // escape internal quotes
    }
    return str;
  };

  // Construct CSV string
  const headers = Object.keys(tableData[0]).map(escapeValue).join(",");
  const rows = tableData
    .map((row) =>
      Object.keys(tableData[0])
        .map((key) => escapeValue(row[key]))
        .join(",")
    )
    .join("\n");

  const csvContent = [headers, rows].join("\n");

  // Create blob with BOM for UTF-8 Excel compatibility
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", csvName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
